import "pixi.js";
import { Observable, Subject } from "rxjs";
import { share, startWith } from "rxjs/operators";
import { supportedImageTypeMiddlewareFactory } from "./supportedImageTypeMiddlewareFactory";
var Loader = PIXI.loaders.Loader;
var UtilLoader = /** @class */ (function () {
    function UtilLoader() {
        var _this = this;
        this.bundleLoaded$ = new Subject();
        this.load = function (id, bundle, loader) { return _this.getLoadingStream$(id, bundle, loader); };
        this.isImageLoaded = function (frameId) { return !!PIXI.utils.TextureCache[frameId]; };
        this.getLoadingStream$ = function (id, bundle, loader) {
            if (loader === void 0) { loader = new Loader(); }
            return Observable.create(function (observer) {
                loader.on("progress", function () { return observer.next(loader); });
                loader.once("error", function (error) {
                    observer.error(error);
                    loader.removeAllListeners();
                });
                Object.keys(bundle).forEach(function (key) { return loader.add(key, bundle[key]); });
                loader.load(function () {
                    _this.bundleLoaded$.next(id);
                    return observer.complete();
                });
            }).pipe(startWith(loader), share());
        };
        // @ts-ignore
        // Ignore needed because we're jumping into Pixi internals here.
        // Unfortunately, there's no other way to put our middleware in front of default ones.
        Loader._pixiMiddleware = [supportedImageTypeMiddlewareFactory].concat(Loader._pixiMiddleware);
    }
    return UtilLoader;
}());
export var utilLoader = new UtilLoader();



//////////////////
// WEBPACK FOOTER
// ./src/utils/loader/utilLoader.ts
// module id = 347
// module chunks = 3